interface EnvironmentProps {
  apiHost: string
  apiGateway: string
  authClientId: string
  authClientSecret: string
  source_email: string

  APP_NAME: string
  APP_MAIN_URL: string
}

const must = (key: keyof ImportMetaEnv): string => {
  const v = import.meta.env[key]
  if (!v || v.trim() === "") {
    throw new Error(`[ENV] Missing required env var: ${key}`)
  }
  return v
}

const environment: EnvironmentProps = {
  apiHost: must("VITE_API_HOST"),
  apiGateway: must("VITE_API_GATEWAY"),
  authClientId: must("VITE_CLIENT_ID"),
  authClientSecret: must("VITE_CLIENT_SECRET"),
  source_email: must("VITE_SOURCE_EMAIL"),

  APP_NAME: "Perk Central",
  APP_MAIN_URL: must("VITE_APP_MAIN_URL"),
}

export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "v0.0"

export default environment
